module.exports = __webpack_public_path__ + "img/filter-type-warmup.7cb59264.svg";